import { UserDetailLang } from './userDetail/userdetail.lang';
import { LoginDetailLang } from './loginDetail/logindetail.lang';
import { ChangePasswordLang } from './changePassword/changePassword.lang';

export const ProfileLang = {
    loginDetail: 'اطلاعات ورود',
    userDetail: 'اطلاعات کاربر',
    username: 'نام کاربری',
    pass: 'پسورد',
    changePass: 'تغییر رمز عبور',
    save: 'ذخیره',
    profile: 'پروفایل',
    userD: UserDetailLang,
    loginD: LoginDetailLang,
    changePassword: ChangePasswordLang,
};
